/****************************************************
 * Module Name:  receiveMaster.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import Constants from "../../utility/constants";
import { DataGridPro, GridToolbar } from "@mui/x-data-grid-pro";
import { Avatar, Box, Button, Chip, Tooltip, Typography, } from "@mui/material";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import renderCellExpand from "../common/dataGridCellExpand";
import Utility from "../../utility/utility";
import CommonSnackbar from "../common/commonSnackBar";
import KapanCreationProxy from "../../utility/proxy/manager/manufacturingProxy/kapanCreationProxy";
import AddReceive from "./addReceiveModal";
import UserProxy from "../../utility/proxy/manager/userProxy";
import KapanHistoryModal from "../manufacturing/operations/kapanHistoryModal";
import PageTitle from "../common/pageTitle";

export class ReceiveMaster extends Component {
  constructor(props) {
    super(props);

    this.state = {
      receive: [],
      showAddReceiveModal: false,

      editOperation: false,
      sourceData: {},
      errorSnackbar: false,
      errorMessage: "",
      snackbarVariant: "",
      loadingButton: false,
      headAvailable: "loading",

      totalKapan: 0,
      totalPrice: 0,
      totalCarats: 0,
      avgPrice: 0,
      columnNames: [],

      showSnackbar: false,
      snackbarMessage: "",

      kapanid: "",
      showKapanDetailModal: false,

      showReceiveLoadSpinner: true,
      local_Permission: Constants.USER_PERMISSION.filter(
        (iPermission) =>
          iPermission.permissionid ===
          Constants.PERMISSIONS.MANUFACTURING_OPERATION_ISSUERECEPT_RECEIPT
      ),
    };
    this.fetchReceiveData(false);
  }

  componentDidMount() {
    PageTitle("MANUFACTURING_OPERATION_KAPANRECEIVE");
  }

  fetchReceiveData = (bAnimateSpinner) => {
    bAnimateSpinner && this.setState({ showReceiveLoadSpinner: true });
    UserProxy.CheckIsUserHead(Constants.loggedInUser.id, (response) => {
      if (response) {
        KapanCreationProxy.GetKapanCreationForReceiveByUserId(
          (responseData) => {
            this.setState({
              receive: responseData,
              showReceiveLoadSpinner: false,
              headAvailable: true,
            })
            const filterMap = this.generateFilterMap(Array.isArray(responseData) ? responseData : [responseData]);
            this.getSummaryReport(responseData);
            this.prepareColumns(filterMap);
          }
        )
      } else {
        this.setState({
          headAvailable: false,
          showReceiveLoadSpinner: false,
        });
      }
    });
  };

  getSummaryReport = (data) => {
    if (!Array.isArray(data)) return;
    let totalKapans = data.length;
    let carats = 0;
    let price = 0;
    data.forEach((item) => {
      carats += item.carats;
      price += item.carats * item.price;
    });
    let avgprice = price / carats;

    this.setState({
      totalKapan: totalKapans,
      totalPrice: price,
      totalCarats: carats,
      avgPrice: avgprice
    });
  }

  generateFilterMap = (responseData) => {
    const filterMap = {};

    // Process department 
    const department = responseData.map((dept) => ({
      id: dept.departmentid,
      username: dept.departmentname,
    }));

    filterMap.departmentname = [
      ...new Set(
        department.map((group) => `${group.id} | ${group.username}`)
      ),
    ];

    // Process department Group
    const departmentGroup = responseData.map((dept) => ({
      id: dept.departmentgroupid,
      username: dept.departmentgroupname,
    }));

    filterMap.departmentgroupname = [
      ...new Set(
        departmentGroup.map((group) => `${group.id} | ${group.username}`)
      ),
    ];

    // Process department 
    const process = responseData.map((dept) => ({
      id: dept.processid,
      name: dept.processname,
    }));

    filterMap.processname = [
      ...new Set(
        process.map((group) => `${group.id} | ${group.name}`)
      ),
    ];

    return filterMap;
  };

  handleKapanDetailModal = (params) => {
    this.setState({ kapanid: params, showKapanDetailModal: true });
  };

  prepareColumns = (uniqueFilterValues) => {

    const columnNames = this.columnsWithoutPermission.map(woPermissionColumn => {
      let guids = [];

      // Determine which GUIDs (permissions) should be added based on the column field

      switch (woPermissionColumn.field) {
        case "id":
          guids = [
            Constants.COLUMN_PERMISSION.MFG_KAPAN_CRTN_USER,
            Constants.COLUMN_PERMISSION.MFG_KAPAN_CRTN_PCS,
            Constants.COLUMN_PERMISSION.MFG_KAPAN_CRTN_CARATS,
            Constants.COLUMN_PERMISSION.MFG_KAPAN_CRTN_PRICE,
            Constants.COLUMN_PERMISSION.MFG_KAPAN_CRTN_TOTAL,
            Constants.COLUMN_PERMISSION.MFG_KAPAN_CRTN_DEPARTMENT,
            Constants.COLUMN_PERMISSION.MFG_KAPAN_CRTN_DEPARTMENT_GROUP,
          ];
          break;
        case "processname":
          guids = [
            Constants.COLUMN_PERMISSION.MFG_KAPAN_CRTN_CREATEDAT,
          ];
          break;
        default:
          guids = [];
      }

      // Retrieve valid permission columns
      return this.fetchColumnDataFromGuid(guids, woPermissionColumn, this.columnsWithPermission, uniqueFilterValues);

    }).flat(); // Flatten the array

    // Update state with the prepared columns
    this.setState({
      columnNames: columnNames
    })
  };

  fetchColumnDataFromGuid = (guids, currentColumn, columnsWithPermission, uniqueFilterValues) => {

    const permissionColumns = guids
      .map(id => Constants.USER_COLUMN_PERMISSION.find(permission => permission === id)) // Match permissions
      .filter(Boolean) // Remove undefined values (invalid permissions)
      .map(guid => {
        const columnData = columnsWithPermission[guid]; // Get column details

        // If the columnData is missing or an empty object, skip adding it
        if (!columnData || Object.keys(columnData).length === 0) {
          return null;
        }

        if (columnData.field === "departmentname") {
          columnData.type = "singleSelect";
          columnData.valueOptions = uniqueFilterValues ? uniqueFilterValues.departmentname : [];
          columnData.filterOperators = Utility.customFilters(uniqueFilterValues, columnData.field, 'departmentid', 'departmentname');
        }
        if (columnData.field === "departmentgroupname") {
          columnData.type = "singleSelect";
          columnData.valueOptions = uniqueFilterValues ? uniqueFilterValues.departmentgroupname : [];
          columnData.filterOperators = Utility.customFilters(uniqueFilterValues, columnData.field, 'departmentgroupid', 'departmentgroupname');
        }

        return columnData;

      })
      .filter(Boolean); // Remove any null values from the list


    if (currentColumn.field === "processname") {
      currentColumn.type = "singleSelect";
      currentColumn.valueOptions = uniqueFilterValues ? uniqueFilterValues.processname : [];
      currentColumn.filterOperators = Utility.customFilters(uniqueFilterValues, currentColumn.field, 'processid', 'processname');
    }

    // Modify the original column before adding it to the list
    const modifiedColumn = {
      ...currentColumn,  // Retain original column properties
      valueOptions: uniqueFilterValues[currentColumn.field] || [], // Assign filter values
    };

    // Return an array with the modified column and any valid permission columns
    return [modifiedColumn, ...permissionColumns];
  };

  columnsWithPermission = {
    "01b85657-9c59-4cda-9c3c-05ea1fd72c7d": {
      field: "pcs",
      headerName: "PCS",
      headerAlign: "center",
      align: "center",
      width: 60,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: (params) => params.value,
    },
    "eebb216a-fc07-4240-984c-55abad8655f8": {
      field: "carats",
      headerName: "CTS",
      headerAlign: "center",
      align: "center",
      width: 80,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: renderCellExpand,
    },
    "8a5f7bcf-0623-4bcc-a449-24ab91c75997": {
      field: "price",
      headerName: "PPC",
      headerAlign: "center",
      align: "center",
      width: 70,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.price)
    },
    "87705e55-c76c-46a4-a15b-da129da04e36": {
      field: "userId",
      headerName: "USER ID",
      headerAlign: "center",
      align: "center",
      width: 150,
      type: "number",
      valueFormatter: (params) => params.value,
    },
    "291073dc-bce6-4b03-9204-9c887e5db384": {
      field: "departmentname",
      headerName: "DEPARTMENT",
      headerAlign: "center",
      align: "center",
      width: 250,
      renderCell: (params) => (
        <Box sx={{ minHeight: "auto", mt: 1 }}>
          <Chip
            avatar={<Avatar>{params.row.departmentid}</Avatar>}
            label={params.row.departmentname}
            sx={{ margin: "0px 10px 10px 0px" }}
          />
        </Box>
      ),
      disableExport: true,
    },
    "13828a45-d41b-402c-a484-41be812749d8": {
      field: "departmentgroupname",
      headerName: "DEPARTMENT GROUP",
      headerAlign: "center",
      align: "center",
      width: 250,
      renderCell: (params) => (
        <Box sx={{ minHeight: "auto", mt: 1 }}>
          <Chip
            avatar={<Avatar>{params.row.departmentgroupid}</Avatar>}
            label={params.row.departmentgroupname}
            sx={{ margin: "0px 10px 10px 0px" }}
          />
        </Box>
      ),
      disableExport: true,
    },
    "f277d253-9fb9-4c5f-9f2f-3e13fb44b1cf": {
      field: "createdAt",
      headerName: "CREATED AT",
      headerAlign: "center",
      align: "center",
      width: 150,
      type: "dateTime",
      valueGetter: (params) => {
        if (params.value) {
          return new Date(params.value);
        }
        return null;
      },
      renderCell: (params) => Utility.ConvertUtcToLocalTime(params.value),
    },
    "c9623b57-4e0d-48b7-8532-ed2fbbd4304b": {
      field: "total",
      headerName: "TOTAL",
      headerAlign: "center",
      align: "center",
      width: 100,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: (params) => (params.row.carats * params.row.price).toFixed(2),
    },
  };

  columnsWithoutPermission = [
    {
      field: "id",
      headerName: "KAPAN ID",
      headerAlign: "center",
      align: "center",
      width: 150,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: (params) => (Utility.NeedToShowKapanDetailModal()) ?
        <Button
          sx={{
            textDecorationLine: "underline",
            color: 'black',
          }}
          onClick={() => this.handleKapanDetailModal(params.value)}
        >
          {params.value}
        </Button>
        :
        <div>{params.value}</div>,
    },
    {
      field: "processname",
      headerName: "CURRENT PROCESS",
      headerAlign: "center",
      align: "center",
      width: 250,
      renderCell: (params) => {
        if (params.row.processid == null || params.row.processname == null)
          return '-';
        return (
          <Box sx={{ minHeight: "auto", mt: 1 }}>
            <Chip
              avatar={<Avatar>{params.row.processid}</Avatar>}
              label={params.row.processname}
              sx={{ margin: "0px 10px 10px 0px" }}
            />
          </Box>
        )
      },
      disableExport: true,
    },
    {
      field: "receive",
      headerName: "RECEIVE",
      headerAlign: "center",
      align: "center",
      width: 150,
      renderCell: (params) => (
        <Button
          variant="contained"
          onClick={() =>
            this.setState({
              showAddReceiveModal: true,
              editOperation: false,
              sourceData: params.row,
              loadingButton: false,
            })
          }
        >
          Receive
        </Button>
      ),
    },
  ];

  hideAddReceiveModal = () => {
    this.setState({
      showAddReceiveModal: false,
    });
  };

  handleValidation = (ReceiveData) => {
    //TODO do validation if needed here
    return true;
  };

  addReceive = (ReceiveData) => {
    this.setState({ loadingButton: true });
    //Creating new receive, and once receive is created on call refresh the list of current receive
    KapanCreationProxy.AddReceive(ReceiveData, (response) => {
      if (response) {
        this.fetchReceiveData(true);
        this.setState({ loadingButton: false, showAddReceiveModal: false });
        this.setSnackbarState(true, response.errorMessage, response.status);
      } else {
        this.setState({ loadingButton: false, showAddReceiveModal: false });
        this.setSnackbarState(true, Constants.APiFailErrorMessage, "error");
      }
    });
  };

  setSnackbarState = (show, message, variant) => {
    this.setState({
      showSnackbar: show,
      snackbarMessage: message,
      snackbarVariant: variant,
    })
  }

  render() {
    const rows = this.state.receive;
    const columns = this.state.columnNames;
    return (
      <Box sx={{ width: "100%", height: "100%" }}>
        <CommonSnackbar
          show={this.state.errorSnackbar}
          message={<Box>{this.state.errorMessage}</Box>}
          variant={this.state.snackbarVariant}
          autoHide={Constants.SnackBarCloseTimer}
          handleClose={() => this.setState({ errorSnackbar: false })}
          title={
            this.state.snackbarVariant === "success" ? "Success" : "Failed"
          }
        />

        <CommonSnackbar
          show={this.state.showSnackbar}
          message={this.state.snackbarMessage}
          variant={this.state.snackbarVariant}
          autoHide={Constants.SnackBarCloseTimer}
          title={this.state.snackbarVariant === "success" ? "Success" :
            this.state.snackbarVariant === "error" ? "Failed" : "Warning"}
          handleClose={() => { this.setState({ showSnackbar: false }) }}
        />

        {this.state.showAddReceiveModal ? (
          <AddReceive
            show={true}
            handleClose={this.hideAddReceiveModal}
            handleSave={this.addReceive}
            handleValidation={this.handleValidation}
            loading={this.state.loadingButton}
            sourceData={this.state.sourceData}
          />
        ) : (
          <Box />
        )}
        {this.state.showKapanDetailModal ? (
          <KapanHistoryModal
            show={this.state.showKapanDetailModal}
            kapanId={this.state.kapanid}
            close={() => this.setState({ showKapanDetailModal: false })}
          />
        ) : null}
        {this.state.headAvailable === "loading" ? (
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "transition(-50%, -50%)",
            }}
          >
            <CircularProgress size="4rem" />
          </Box>
        ) : !this.state.headAvailable ? (
          <Box>
            <Typography>
              Currently you are not heading any department
            </Typography>
          </Box>
        ) : (
          <Box>
            <Box px={1}>
              <Box
                sx={{
                  backgroundColor: '#fff',
                  color: '#000',
                  width: "100%",
                  position: "relative",
                  "& .MuiTablePagination-selectLabel": {
                    marginTop: "15px",
                  },
                  "& .MuiTablePagination-displayedRows": {
                    marginTop: "15px",
                  },
                  "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                    fontWeight: Constants.defaultFontWeight,
                  },
                  "& .css-cc8tf1": {
                    fontWeight: Constants.defaultFontWeight,
                  },
                  height: "77vh",
                }}
              >
                <DataGridPro
                  disableRowSelectionOnClick={true}
                  getRowHeight={() => "auto"}
                  sx={{
                    '& .MuiDataGrid-columnHeader': {
                      color: '#fff',
                      backgroundColor: 'grey',
                    },
                    "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                      py: "4px",
                    },
                    "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                      py: "12px",
                    },
                    "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                      py: "18px",
                    },

                    fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
                  }}
                  density="compact"
                  slots={{ toolbar: GridToolbar }}
                  rows={rows}
                  columns={columns}
                  getRowId={(row) => row.id}
                  loading={this.state.showReceiveLoadSpinner}
                  initialState={{
                    columns: {
                      columnVisibilityModel: {
                        // Hide columns status and traderName, the other columns will remain visible
                      },
                    },
                    pagination: {
                      paginationModel: Constants.pageSize,
                    },
                  }}
                  pageSizeOptions={Constants.pageSizeOptions}
                  pagination
                  slotProps={{
                    toolbar: {
                      showQuickFilter: true,
                      quickFilterProps: { debounceMs: 500 },
                    },
                  }}
                />
                <Box
                  sx={{
                    position: "absolute",
                    top: "11px",
                    left: "590px",
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '36rem',
                    color: "black",
                    fontWeight: 'normal',
                    fontSize: Constants.defaultTableFontSize
                  }}
                ><p style={{ margin: 0 }}>
                    <span>Total Kapan:</span> <b>{this.state.totalKapan}</b> &nbsp;&nbsp;|&nbsp;&nbsp;
                    <span>Total Carats: </span> <b>{this.state.totalCarats.toFixed(2)}</b>  &nbsp;&nbsp;|&nbsp;&nbsp;
                    <span>Total Price: </span> <b>{this.state.totalPrice.toFixed(2)}</b>  &nbsp;&nbsp;|&nbsp;&nbsp;
                    <span>Avg Price: </span> <b>{isNaN(this.state.avgPrice) ? "0.00" : this.state.avgPrice.toFixed(2)}</b></p>
                </Box>

                <Box
                  style={{
                    position: "absolute",
                    top: 5,
                    right: "270px",
                  }}
                >
                  {this.state.showReceiveLoadSpinner ? (
                    <CircularProgress size="25px" sx={{ lineHeight: -2 }} />
                  ) : (
                    <Tooltip title="Reload List">
                      <RefreshOutlinedIcon
                        color="primary"
                        fontSize="medium"
                        onClick={() => this.fetchReceiveData(true)}
                        sx={{ cursor: "pointer" }}
                      />
                    </Tooltip>
                  )}
                </Box>
              </Box>
            </Box>
          </Box>
        )}
      </Box>
    );
  }
}

export default ReceiveMaster;
